import type { CSSProperties, LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import "./Status.linaria.module.css!=!./Status?./Status.linaria.module.css?css=H4sIAAAAAAAAA22Qy26DMBBF9/0KpKpLRxgQSd2PsYwfwYnxuPYQoFb/vQoqqYi6PLr3zGjmIHDgTc3p0jTgzGGPuYOodCQdIMJAnDZIolB2TKwJ88f3y9pv5U7/w01HCCTac/+fbCSnfQuX8esJ82VMaM1CJHjUHpnUHnXcvH6nPSgLZ8+eWNRDejIqxcf2aGjaU+6EvJ4jjF4RCQ4iezXGbJJM/ORrWnV7ygY8kknfj2IdOLX13xOnOE/25rKyKTixMOP049qj41S1w6Iv+XdXXddbeG14OyulugxBSIsLKw+nLbwtnEL6hOqWJ6uwZ7Qs3x5jS07tKSh/f/lMUi8UTOvsogxzQcNcVOvLfwCtI1jX7wEAAA=="
interface StatusBadgeProps {
  className?: LinariaClassName;
  style?: CSSProperties;
  shadow?: boolean;
  status: string;
}
const stylesRoot = "atm_43_1y44olf atm_6c_1y44olf atm_fc_1h6ojuz atm_h_1h6ojuz atm_2d_u67f1s atm_cs_8n312b atm_9s_1txwivl atm_7l_1d6myej atm_k4_6xdddb atm_vy_1osqo2v";
const stylesShadow = "atm_70_1i8pdnf";
const StatusBadge = memo((props: StatusBadgeProps) => {
  const {
    className,
    shadow,
    status,
    style
  } = props;
  return <div data-testid={`Badge__${status}`} className={cx(shadow && stylesShadow, stylesRoot, className)} style={style}>
            {status}
        </div>;
});
export default StatusBadge;
export { StatusBadge };